<div class="block-header" style="position: fixed;
display: contents;">
    <!-- <div class="row">
       <div class="example-button-row mb-3">
          <ng-container *ngFor="let menu of headerMenuList">
             <button mat-raised-button class="example-add-tab-button msr-2"
             [routerLink]="[menu.functionURL]" routerLinkActive="primary-color"
                  [routerLinkActiveOptions]="{exact: true}">
                {{menu.menuLinkName}}
             </button>
          </ng-container>
       </div>
    </div> -->
    <div class="page_title">
        <ul class ="list-items">
            <li *ngFor="let menu of headerMenuList" >
                <button mat-raised-button class="example-add-tab-button" style="margin-right: 2px;"
                [routerLink]="[menu.functionURL]" [ngClass]="checkActivelink(menu)"
                     (click)="setPermission(menu.permission,menu.menuLinkId)">
                   {{menu.menuLinkName}}
                </button>
            </li>
        </ul>
    </div>
</div>